var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c("Subheader", {
        attrs: { dense: "", title: "Guideline Details", "no-search": "" },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              ref: "form",
              staticStyle: { width: "100%" },
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "pl-3": "", "pr-3": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Guideline Long Name",
                              rules: _vm.guidelineLongNameRules,
                            },
                            model: {
                              value: _vm.guidelineData.GuidelineLongName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.guidelineData,
                                  "GuidelineLongName",
                                  $$v
                                )
                              },
                              expression: "guidelineData.GuidelineLongName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              label: "Guideline short Name",
                              rules: _vm.guidelineShortNameRules,
                            },
                            model: {
                              value: _vm.guidelineData.GuidelineName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.guidelineData,
                                  "GuidelineName",
                                  $$v
                                )
                              },
                              expression: "guidelineData.GuidelineName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-combobox", {
                            ref: "category",
                            attrs: {
                              label: "Category",
                              items: _vm.guidelinesCategory,
                              rules: _vm.categoryRules,
                            },
                            model: {
                              value: _vm.guidelineData.Category,
                              callback: function ($$v) {
                                _vm.$set(_vm.guidelineData, "Category", $$v)
                              },
                              expression: "guidelineData.Category",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "Media Types",
                              items: _vm.mediaTypeList,
                              multiple: "",
                              "item-text": "Name",
                              rules: _vm.mediaTypeRules,
                              "return-object": "",
                            },
                            model: {
                              value: _vm.guidelineData.Medias,
                              callback: function ($$v) {
                                _vm.$set(_vm.guidelineData, "Medias", $$v)
                              },
                              expression: "guidelineData.Medias",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { block: "", color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.clickSave()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }